import * as React from 'react';
import * as main from "../../main.module.scss";
import * as ans from "./style.module.scss";
export const Answers = () => {
  return (
    <section className={ans.answers}>
      <div className="container">
        <h2 className={main.title}>Вы получите ответы на вопросы:</h2>
        <div className={ans.wrap}>
          <ul>
            <li>Как мотивировать ребенка учиться хорошо?</li>
            <li>Стоит ли заставлять ребенка делать домашнее задание?</li>
            <li>Что делать, если ребенок отстает от школьной программы?</li>
            <li>Как сдать ЕГЭ и поступить в ВУЗ?</li>
          </ul>
          <img src="https://fs.advance.ru/landing-pages/webinar/nauchite_detey_uchitsya/_dontspeak/students.png" alt={""}/>
        </div>
      </div>
    </section>
  );
};
